export default __webpack_public_path__ + "static/media/spin.3f131a4a.gif";